"use client";

import React from "react";
import styled from "styled-components";

import Button, { Props as ButtonProps } from "../Button/Button";
import Flex from "../Flex";
import Box, { BoxProps } from "../Box";
import Text from "../Text";

const SectionHeading = styled(Flex).attrs({
  background: "white",
  flexDirection: "row",
  px: "m",
  pb: "xs",
  pt: "m",
  justifyContent: "space-between",
  textAlign: "left",
  position: "sticky",
  top: 0,
  zIndex: 5,
})``;

// Wrapper is used to avoid adding a border to the first section header
// but still contain the contents of each section
type SectionContainerProps = BoxProps & {
  hasTitle: boolean;
};
const SectionContainer = styled(Box).attrs<SectionContainerProps>(props => {
  return {
    borderTop: props.hasTitle ? "none" : "default",
    variations: {
      "&:first-child": {
        borderTop: "none",
      },
    },
    ...props,
  };
})<SectionContainerProps>``;

export type SectionProps = {
  id?: string;
  title?: string;
  children?: React.ReactNode;
  button?: ButtonProps;
} & BoxProps;

const Section: React.FC<SectionProps> = ({ id, title, children, button, ...rest }) => {
  function renderHeader() {
    const headerButton = (() => {
      if (!button || !button.text) return null;
      return <Button {...button} buttonStyle="tertiary" size="small" m={0} />;
    })();
    if (!title && !headerButton) return null;
    return (
      <SectionHeading data-testid="menu-section-heading">
        <Text truncate font="ui.smallBold" color="grayDarkest">
          {title}
        </Text>
        {headerButton}
      </SectionHeading>
    );
  }

  const header = renderHeader();
  if (!header && !children) return null;
  return (
    <SectionContainer data-testid={id} hasTitle={!!title} {...rest}>
      {header}
      {children}
    </SectionContainer>
  );
};

export default Section;
